import {Typography} from '@mui/material'
import {styled} from '@mui/material/styles'
import Avatar from '@mui/material/Avatar'

const Legend = styled(Avatar)(() => ({
  height: 16,
  width: 16
}))

const StyledTitleTypography = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightSemibold,
  fontSize: theme.typography.subtitle2.fontSize,
  color: theme.palette.hpAccentBlack,
  lineHeight: '16px',
  letterSpacing: 0.21
}))

const StyledTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  marginLeft: '8px',
  wordBreak: 'break-word',
  textWrap: 'wrap',
  letterSpacing: 0.21
}))

const StyledOuterDiv = styled('div')(({theme}) => ({
  backgroundColor: theme.palette.hpWhite,
  padding: theme.spacing(2),
  borderRadius: 4,
  maxWidth: '200px'
}))

const StyledInnerDiv = styled('div')(() => ({
  display: 'flex',
  padding: '4px 0px',
  alignItems: 'center'
}))

export {Legend, StyledTitleTypography, StyledTypography, StyledOuterDiv, StyledInnerDiv}
